import {
  SET_COMET_USER_STATE,
  SET_COMET_USER_DATA,
  SET_COMET_USER_UID,
  SET_REFERRAL_ORDER,
  SET_COMET_CHAT_WITH_UID,
  SET_NOT_LOGGED_IN_CONTEXT,
  RESET_COMET_STATE
} from './cometChatActions'

const initialState = {
  cometChatUserState: 0, //0: app not initialized, 1: app initialized, 2: user logged in
  cometUserData: undefined,
  currentUid: undefined,
  chatReceiverUid: undefined,
  notLoggedInContext: 0, //0: no, 1: yes (type: search task), 2: yes (type: search expert)
  orderIdContext: undefined
}

const cometChatReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_COMET_USER_STATE:
      return {
        ...state,
        cometChatUserState: payload,
      };

    case SET_COMET_USER_DATA:
      return {
        ...state,
        cometUserData: payload,
      };


    case SET_COMET_USER_UID:
      return {
        ...state,
        currentUid: payload,
      };

    case SET_COMET_CHAT_WITH_UID:
      return {
        ...state,
        chatReceiverUid: payload,
      };

    case SET_REFERRAL_ORDER:
      return {
        ...state,
        orderIdContext: payload,
      };

    case SET_NOT_LOGGED_IN_CONTEXT:
      return {
        ...state,
        isNotLoggedInContext: payload,
      };

    case RESET_COMET_STATE:
      return {
        cometChatUserState: 0,
        currentUid: undefined,
        chatReceiverUid: undefined,
        isNotLoggedInContext: 0,
        orderIdContext : undefined,
      }

    default:
      return state;
  }
};

export default cometChatReducer;